// extracted by mini-css-extract-plugin
module.exports = {"update":"PhotoUpdate_update__3b6hS"};